module.exports = __webpack_public_path__ + "static/media/logo_ppdb_online_domsav.5d34e543.png";